import {
  DeliveryForecastDespatchAdvicePackaging,
  DeliveryForecastDespatchAdvicePackagingItem,
} from '../../data/models'

type PackagedQuantityCalculationResult = number | null

export function calculatePackagingQuantity(
  packaging?: DeliveryForecastDespatchAdvicePackaging,
): PackagedQuantityCalculationResult {
  if (!packaging) return null
  if (!packaging.Items || packaging.Items.length < 1) return null

  return calculatePackagingItemsQuantity(packaging.Items)
}

function calculatePackagingItemsQuantity(
  packagingItems: DeliveryForecastDespatchAdvicePackagingItem[],
): PackagedQuantityCalculationResult {
  let currentQuantity = 0

  packagingItems.forEach(item => {
    currentQuantity += item.Quantity?.Value || 0
    if (item.Items && item.Items.length > 0)
      currentQuantity += calculatePackagingItemsQuantity(item.Items) || 0
  })

  return currentQuantity
}
